import Page from './Page';
export default Page;
export { default as Grid } from './Grid';
export { default as GridColumn } from './GridColumn';
//# sourceMappingURL=index.js.map